import { schema } from "normalizr";
import segmentSchema from "./segment";
import imageSchema from "./image";

const audienceSchema = new schema.Entity(
    "audiences",
    {
        segments: [segmentSchema],
        iconImage: imageSchema
    },
    { idAttribute: "id" }
);

export default audienceSchema;



// WEBPACK FOOTER //
// ./src/schemas/audience.js